import ArrowGoBack from "../../components/ArrowGoBack/ArrowGoBack";
import styles from "./index.module.css";
import { connect } from "react-redux";
import {
  getLoginDeviceLifetime,
  updateLoginDeviceLifetime,
} from "../../actions/clientAction";
import { useEffect, useState } from "react";
import {
  closeLoading,
  openLoading,
} from "../../components/loadingModal/loading";
import alert from "../../components/AlertModal/alertModal";
import confirm from "../../components/ConfirmModal/confirm";
import settingsIcon from "../../assets/icons/navbar/settings.png";
import Button from "../../components/Button";

const MAX_HOURS = 2880; // 120 days

const Template = (props) => {
  const { time, getLoginDeviceLifetime, updateLoginDeviceLifetime } = props;

  const [state, setState] = useState({
    hour: 0,
    minute: 0,
  });

  const [isEditing, setIsEditing] = useState(false);

  const getInitialData = async () => {
    openLoading();
    try {
      await getLoginDeviceLifetime();
      //   setState({
      //     hour: Math.floor(time / 3600),
      //     minute: Math.floor((time % 3600) / 60),
      //   });
    } catch (error) {
      alert("ERROR", error.message);
    } finally {
      closeLoading();
    }
  };

  useEffect(() => {
    getInitialData();
  }, []);

  useEffect(() => {
    if (time !== undefined) {
      setState({
        hour: Math.floor(time / 3600),
        minute: Math.floor((time % 3600) / 60),
      });
      console.log("Updated time from props:", time);
    }
  }, [time]);

  const handleChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setState({
      ...state,
      [e.target.name]:
        value === "" ? 0 : Math.min(parseInt(value), MAX_HOURS),
    });
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setState({
      hour: Math.floor(time / 3600),
      minute: Math.floor((time % 3600) / 60),
    });
    setIsEditing(false);
  };

  const handleSubmit = async () => {
    const seconds = state.hour * 3600 + state.minute * 60;

    if (seconds < 60) {
      alert("WARNING", "Duration must be at least 1 minute");
      return;
    }

    const confirmation = await confirm(
      "CONFIRM",
      "Do you want to update the login duration on device?",
    );

    if (!confirmation) return;

    try {
      openLoading();
      await updateLoginDeviceLifetime(seconds);
      await getLoginDeviceLifetime();
      alert("SUCCESS", "Login duration updated successfully");
      setIsEditing(false);
    } catch (error) {
      alert("ERROR", error);
    } finally {
      closeLoading();
    }
  };

  const defaultHour = 3;
  const defaultMinute = 0;

  return (
    <div className={`box-container ${styles.container}`}>
      <ArrowGoBack />
      <div className={styles.contentWrapper}>
        <div className={styles.rightSection}>
          <div className={styles.header}>
            <img src={settingsIcon} alt="Settings" className={styles.icon} />
            <div className={styles.headerTitle}>
              <h1>Device Login Settings</h1>
              <p>Configure how long users stay logged in on their devices</p>
            </div>
          </div>

          <div className={styles.content}>
            <div className={styles.section}>
              <div className={styles.sectionHeader}>
                <h2>Login Duration</h2>
                <span className={styles.badge}>Active</span>
              </div>

              <div className={styles.durationDisplay}>
                <div className={styles.currentDuration}>
                  <label>Current Duration</label>
                  <div className={styles.timeValue}>
                    {isEditing ? (
                      <div className={styles.inputGroup}>
                        <div className={styles.timeInput}>
                          <input
                            type="text"
                            name="hour"
                            value={state.hour}
                            onChange={handleChange}
                            onKeyPress={(e) =>
                              !/[0-9]/.test(e.key) && e.preventDefault()
                            }
                            className={styles.input}
                            maxLength="4"
                          />
                          <span className={styles.unit}>Hours</span>
                          <span className={styles.maxNote}>
                            Max {MAX_HOURS} hours = {MAX_HOURS / 24} days
                          </span>
                        </div>
                        {/* <span className={styles.separator}>:</span>
                        <div className={styles.timeInput}>
                          <input
                            type="text"
                            name="minute"
                            value={state.minute}
                            onChange={handleChange}
                            onKeyPress={(e) =>
                              !/[0-9]/.test(e.key) && e.preventDefault()
                            }
                            className={styles.input}
                            maxLength="2"
                          />
                          <span className={styles.unit}>minutes</span>
                        </div> */}
                      </div>
                    ) : (
                      <span className={styles.displayTime}>
                        {state.hour} Hours
                        {/* {state.minute > 0 ? `${state.minute}m` : ""} */}
                      </span>
                    )}
                  </div>
                </div>

                <div className={styles.divider}></div>

                <div className={styles.defaultDuration}>
                  <label>Default Duration</label>
                  <div className={styles.timeValue}>
                    <span className={styles.displayTime}>
                      {defaultHour} Hours
                      {defaultMinute > 0 ? `${defaultMinute}m` : ""}
                    </span>
                  </div>
                </div>
              </div>

              <div className={styles.infoBox}>
                <svg
                  className={styles.infoIcon}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V9H11V15ZM11 7H9V5H11V7Z"
                    fill="currentColor"
                  />
                </svg>
                <p>
                  When “Remember Me” box is checked , your session into the
                  device will remain active for the duration selected below. For
                  your security, use this feature only on trusted devices.
                </p>
              </div>

              <div className={styles.actions}>
                {isEditing ? (
                  <>
                    <Button
                      type="light"
                      onClick={handleCancel}
                      label="Cancel"
                      size="medium"
                      styleButton="light"
                    />
                    <Button
                      type="main"
                      onClick={handleSubmit}
                      label="Save Changes"
                      size="medium"
                      styleButton="main"
                    />
                  </>
                ) : (
                  <Button
                    type="main"
                    onClick={handleEdit}
                    label="Edit"
                    size="medium"
                    styleButton="main"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.leftSection}>
          <div className={styles.imgContainer}>
            <img
              src="https://qrfilesrepo.blob.core.windows.net/web-assets/img/Tablet4x.png"
              alt="ref"
              className={styles.sideImg}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    time: state.client.deviceLoginDuration,
  };
};

export default connect(mapStateToProps, {
  getLoginDeviceLifetime,
  updateLoginDeviceLifetime,
})(Template);
